<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>{{ title }}</b-card-title>
    </b-card-header>

    <b-card-body>
      <line-chart v-if="loaded" :chartdata="chartdata" :options="options" />
    </b-card-body>
  </b-card>
</template>

<script>
import LineChart from "./Chart.vue";

export default {
  name: "LineChartContainer",
  components: { LineChart },
  props: {
    title: String,
    labels: [],
    data: [],
  },
  data: () => ({
    loaded: false,
    chartdata: null,
    options: {
      responsive: true,
      plugins: {
        legend: {
          position: "top",
        },
        title: {
          display: true,
          text: "Chart.js Polar Area Chart",
        },
      },
    },
  }),
  mounted() {},
  created() {
    this.setData();
  },
  methods: {
    async setData(report) {
      this.loaded = false;
      // this.title = "Sssssssssssssssssssss";
      // this.controller = new Controller(this.$route.params.pollId);
      let chartdata = {
        labels: this.labels,
        datasets: [
          {
            label: this.labels,
            backgroundColor: [
              this.getRandomColor(),
              this.getRandomColor(),
              this.getRandomColor(),
              this.getRandomColor(),
            ],
            data: this.data,
          },
        ],
      };
      this.chartdata = chartdata;
      this.loaded = true;
    },
    drawData(data) {
      // console.log(data);
      let reportData = [];
      let labels = [];
      for (const [key, value] of Object.entries(data)) {
        reportData.push(value);
        labels.push(key);
      }
      return { reportData, labels };
    },
    getRandomColor() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
  },
};
</script>